export function isPrimitive(value: unknown) {
  return value == null || /^[sbn]/.test(typeof value);
}
